<template>
  <div class="edit-profile px30 pt-8 flex flex-col">
    <div v-if="isEditProfile">
      <button
        v-ripple
        type="button"
        class="btn-empty-wrapper mr-5 mb-5"
        @click="clickHandler"
      >
        <Close icon="back" />
      </button>
      <h3
        class="
          page-title
          font-bold
          text-28 text-text
          tracking-tight
          leading-tight
          mb-2
        "
      >
        <span class="text-primary">{{ $t("Edit") }}</span>
        <span class="text-secondary">{{ $t("Profile") }}</span>
      </h3>
      <p class="text-12 tracking-normal text-text opacity-60">
        {{ $t("Change your account details") }}
      </p>
      <div
        class="form-items form-with-icons pt-10 flex flex-col flex-grow"
        :class="{
          'form-enabled': values.name !== '' && values.email !== '' && hasAvatar
        }"
      >
        <PhotoUploader @addAvatar="addAvatar" />
        <FormulateForm #default="{ hasErrors }" v-model="values">
          <div v-for="item in schema" :key="item.name">
            <div v-if="item.name === 'phone'">
              <vue-tel-input
                class="telephone mb-5"
                :placeholder="item.placeholder"
                :label="item.label"
                v-model="values.phone"
                :dropdownOptions="dropdownOptions"
                @input="checkPhone"
                disabled
              >
              </vue-tel-input>
              <div class="mb-10 text-left">
                <span class="text-14 text-light_grey"
                  >Do you want to update your Phone Number</span
                >
                <span
                  class="text-16 text-primary font-bold"
                  @click="isUpdatePhone = true"
                >
                  Click Here
                </span>
              </div>
            </div>
            <FormulateInput v-else v-bind="item" :hasErrors="hasErrors" />
          </div>
        </FormulateForm>
      </div>
    </div>
    <div v-if="isUpdatePhone" class="confirm-phone-number flex flex-col">
      <span @click="reset('isUpdatePhone')">
        <Close icon="back" />
      </span>
      <ConfirmPhoneNumber
        :phone="userPhone"
        :title="confirmTitle"
        content="Please update your Phone Number, a OTP will be sent on your registered Mobile Number. If you change the number it will be saved in your profile"
        @next="sendOTP"
      />
    </div>
    <PhoneVerification
      v-if="isPhoneVerification"
      through="update"
      :phone="userPhone"
      end-point="/user/verify_otp"
      :show-update-phone="true"
      para-two="to verify and activate your account"
      @update-phone="isUpdatePhone = true"
      @success="reset('isPhoneVerification')"
      @sendSMS="sendOTP"
    />
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import Close from "../UI/Close";
import PhotoUploader from "../PhotoUploader/PhotoUploader";
import ConfirmPhoneNumber from "../Login/ConfirmPhoneNumber.vue";
import PhoneVerification from "../Login/PhoneVerification.vue";

export default {
  name: "EditProfile",

  components: {
    VueTelInput,
    Close,
    PhotoUploader,
    ConfirmPhoneNumber,
    PhoneVerification
  },

  props: ["clickHandler"],

  data: function() {
    return {
      values: {
        email: this.$user("email"),
        name: this.$user("name"),
        phone: this.$user("phone")
      },
      avatar: "",
      schema: [
        {
          type: "email",
          name: "email",
          label: ".",
          placeholder: this.$t("Email"),
          validation: "required|email"
        },
        {
          type: "text",
          name: "name",
          label: ".",
          placeholder: this.$t("Name"),
          validation: "required"
        },
        {
          type: "tel",
          name: "phone",
          label: ".",
          placeholder: this.$t("Phone"),
          validation: "required|number|max:12,length|starts_with:+",
          help: "+16175551212"
        },
        {
          type: "customButton",
          label: this.$t("Save"),
          formHandler: this.formHandler
        }
      ],
      dropdownOptions: {
        showDialCodeInSelection: true,
        showFlags: true
      },
      isUpdatePhone: false,
      isPhoneVerification: false
    };
  },

  computed: {
    hasAvatar: function f() {
      if (!this.avatar && this.$user("has_avatar") === 1) {
        return true;
      } else return !!this.avatar;
    },
    userPhone() {
      return this.values.phone;
    },
    isEditProfile() {
      return !this.isUpdatePhone && !this.isPhoneVerification;
    },
    confirmTitle() {
      return ` <span class="text-primary">Update</span>
        <span class="text-content">Phone Number</span>`;
    }
  },

  methods: {
    checkPhone: function(number, phoneObject) {
      if (phoneObject.number !== undefined) {
        this.values.phone = phoneObject.number;
      } else {
        this.values.phone = number;
      }
    },
    formHandler: function() {
      if (this.avatar) {
        this.values.avatar = this.avatar;
      }

      if (this.values.name && this.values.email && this.values.phone) {
        this.$http.post("user/saveprofile", this.values).then(res => {
          if (res && res.status !== undefined && res.status) {
            this.$setState("userUpdate", res.data.user);
          }
        });
      }
    },
    addAvatar: function(img) {
      this.avatar = img;
    },
    async sendOTP(phone) {
      const paylaod = {
        phone
      };
      const res = await this.$http.post("user/send_otp", paylaod);
      if (!res.status) return;
      this.values.phone = this.$store.state.user.phone = phone;
      this.isPhoneVerification = true;
      this.isUpdatePhone = false;
    },
    reset (field) {
      this[field] = false
      this.values = {
        email: this.$user("email"),
        name: this.$user("name"),
        phone: this.$user("phone")
      };
    }
  }
};
</script>
<style scoped>
.confirm-phone-number {
  height: calc(100vh - 110px);
}
</style>
